<template>
  <a-drawer
    :maskClosable="false"
    width="75%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />

    <a-form-model
      :model="form"
      ref="form"
      :label-col="{ span: 3 }"
      :rules="rules"
      :wrapper-col="{ span: 10 }"
      class="padding-lr"
    >
      <a-tabs tab-position="top" v-model="tabIndex">
        <a-tab-pane :key="1" tab="基础信息">
          <a-row :gutter="12">
            <a-col :span="24">
              <a-form-model-item label="维修分类" prop="categoryId" class="margin-bottom-10">
                <a-select
                  show-search
                  :allowClear="true"
                  v-model="form.categoryId"
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option v-for="d in cateList" :key="d.id">{{ d.categoryName }}</a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item label="产品名称" prop="prodName" class="margin-bottom-10">
                <a-input v-model="form.prodName" placeholder="请输入" />
              </a-form-model-item>
              <a-form-model-item label="维修基础原价" prop="oriPrice">
                <a-input v-model="form.oriPrice" type="number" placeholder="请输入" :maxLength="500" allow-clear />
              </a-form-model-item>
              <a-form-model-item label="维修基础现价	" prop="price">
                <a-input v-model="form.price" type="number" placeholder="请输入" :maxLength="500" allow-clear />
              </a-form-model-item>
              <a-form-model-item label="排序" prop="sort">
                <a-input v-model="form.sort" type="number" placeholder="请输入" :maxLength="500" allow-clear />
              </a-form-model-item>
              <a-form-model-item label="产品简述" prop="brief">
                <a-input v-model="form.brief" type="textarea" placeholder="请输入" :maxLength="500" allow-clear />
              </a-form-model-item>
              <a-form-model-item label="产品主图" prop="pic">
                <file-upload
                  type="image"
                  :defaultList="form.pic"
                  @input="getImg($event, 'pic')"
                  :file="form.pic"
                  :count="1"
                  :autoCropHeight="210"
                  :autoCropWidth="164"
                ></file-upload>
              </a-form-model-item>
              <a-form-model-item label="产品图册" prop="img">
                <file-upload
                  type="image"
                  :defaultList="form.img"
                  @input="getImg($event, 'img')"
                  :file="form.img"
                  :count="6"
                  :autoCropHeight="350"
                  :autoCropWidth="350"
                ></file-upload>
              </a-form-model-item>
              <a-form-model-item label="维修视频">
                <file-upload
                  type="video"
                  :defaultList="form.video"
                  @input="getImg($event, 'video')"
                  :file="form.video"
                  :count="1"
                  :autoCropHeight="350"
                  :autoCropWidth="350"
                ></file-upload>
              </a-form-model-item>
              <a-form-model-item label="备注">
                <a-input v-model="form.remark" type="textarea" placeholder="请输入" :maxLength="500" allow-clear />
              </a-form-model-item>
              <a-divider></a-divider>
              <a-row style="margin: 30px 0">
                <a-col :span="2"></a-col>
                <a-col :span="12" class="margin-tb-lg">
                  <a-button type="primary" size="large" @click="changeTab(1, 'next')">下一步</a-button>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane :key="2" tab="规格">
          <div>
            <!-- <a-form-model-item label="请选择规格">
              <a-select
                v-model="curSpec"
                show-search
                placeholder="请选择规格"
                style="width: 200px"
                @change="handleChangeSpec"
              >
                <a-select-option :value="item.id" v-for="(item, index) in form.specList" :key="index">
                  {{ item.label }}
                </a-select-option>
              </a-select>
              <a-button v-if="curSpec" type="primary" @click="isShowSpec = true">确定</a-button>
            </a-form-model-item> -->
            <!-- start展示选择的规格信息 -->
            <div v-if="isShowSpec && form.specList.length">
              <div class="box margin-bottom-sm" v-for="(item, index) in form.specList[0].specs" :key="index">
                <div class="margin-bottom-xs">
                  {{ item.label }}
                  <a-icon type="close-circle" class="cursorhand margin-left-sm" @click="delSpec(index)" />
                </div>
                <div class="flex align-center">
                  <div v-for="(item1, index1) in item.spec_value" :key="index" class="flex align-center">
                    <a-input v-model="item1.label" placeholder="请输入" size="small" style="width: 80%" />
                    <a-button
                      v-if="index1 + 1 === item.spec_value.length"
                      type="primary"
                      size="small"
                      @click="add(2, index, index1)"
                      class="margin-left-sm margin-right"
                    >
                      添加
                    </a-button>
                    <a-icon
                      type="close-circle"
                      class="cursorhand margin-left-sm"
                      @click="del(2, index, index1)"
                    ></a-icon>
                  </div>
                </div>
              </div>
            </div>
            <!-- end  展示选择的规格信息 -->
            <div v-for="(spec, i) in specs" :key="i" style="margin-bottom: 12px">
              <a-input v-model="spec.label" placeholder="规格名（如颜色）" style="width: 200px; margin-right: 8px" />
              <a-tag v-for="(val, j) in spec.spec_value" :key="j" closable @close="spec.spec_value.splice(j, 1)">
                {{ val.label }}
              </a-tag>
              <a-input
                v-if="spec.inputVisible"
                :ref="'input' + i"
                type="text"
                size="small"
                style="width: 78px"
                @blur="
                  (e) => {
                    if (e.target.value.trim()) {
                      spec.spec_value.push({ label: e.target.value.trim() })
                    }
                    spec.inputVisible = false
                  }
                "
              />
              <a-tag
                v-else
                style="background: #fff; borderstyle: dashed"
                @click="
                  () => {
                    spec.inputVisible = true
                    this.$nextTick(() => this.$refs['input' + i][0].focus())
                  }
                "
              >
                + 添加值
              </a-tag>
              <a-icon type="close-circle" @click="specs.splice(i, 1)" style="margin-left: 8px; cursor: pointer" />
            </div>

            <a-button type="dashed" @click="specs.push({ label: '', spec_value: [], inputVisible: false })">
              + 添加规格
            </a-button>

            <a-button class="margin-tb" type="primary" @click="generateSkuList">立即生成</a-button>
            <!-- start 根据所选的规格，生成skuList,展示表格 -->
            <a-table
              :loading="loading"
              size="small"
              rowKey="postId"
              :columns="skuColumns"
              :data-source="skuList"
              :pagination="false"
              :bordered="true"
            >
              <template slot="skuNameInput" slot-scope="text, record, index">
                <a-input v-model="addParams[index].skuName" />
              </template>

              <template slot="price" slot-scope="text, record, index">
                <a-input-number v-model="addParams[index].price" :min="0" />
              </template>

              <template slot="oriPrice" slot-scope="text, record, index">
                <a-input-number v-model="addParams[index].oriPrice" :min="0" />
              </template>

              <template slot="referencePrice" slot-scope="text, record, index">
                <a-input v-model="addParams[index].referencePrice" />
              </template>

              <template slot="maxPrice" slot-scope="text, record, index">
                <a-input-number v-model="addParams[index].maxPrice" :min="0" />
              </template>

              <template slot="totalStocks" slot-scope="text, record, index">
                <a-input-number v-model="addParams[index].totalStocks" :min="0" />
              </template>

              <template slot="pic" slot-scope="text, record, index">
                <file-upload
                  type="image"
                  :count="1"
                  :file="addParams[index].pic"
                  @input="(url) => this.$set(this.addParams[index], 'pic', url)"
                />
              </template>

              <template slot="sort" slot-scope="text, record, index">
                <a-input-number v-model="addParams[index].sort" :min="0" />
              </template>

              <template slot="status" slot-scope="text, record, index">
                <a-switch
                  checked-children="启用"
                  un-checked-children="禁用"
                  v-model="addParams[index].status"
                  :checked-value="1"
                  :un-checked-value="0"
                />
              </template>
            </a-table>
            <!-- end   根据所选的规格，生成skuList,展示表格 -->
          </div>
          <a-divider></a-divider>
          <a-row style="margin: 30px 0">
            <a-col :span="2"></a-col>
            <a-col :span="12" class="margin-tb-lg">
              <a-button @click="changeTab(2, 'back')" size="large" class="margin-right">上一步</a-button>
              <a-button @click="changeTab(2, 'next')" type="primary" size="large">下一步</a-button>
            </a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane :key="3" tab="其他设置">
          <a-form-model-item label="商品详情" prop="content" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
            <editor v-model="form.content" />
          </a-form-model-item>
          <a-divider></a-divider>
          <a-row style="margin: 30px 0">
            <a-col :span="2"></a-col>
            <a-col :span="12" class="margin-tb-lg">
              <a-button @click="submitForm" type="primary" size="large">保存</a-button>
            </a-col>
          </a-row>
        </a-tab-pane>
      </a-tabs>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { getObj, addObj, putObj } from '@/api/pressure/goods'
import editor from '@/components/Editor/Editor.vue'
export default {
  name: 'CreateForm',
  props: {
    // statusOptions: {
    //   type: Array,
    //   required: false,
    // },
    cateList: {
      type: Array,
      required: true,
    },
  },
  components: { editor },
  data() {
    const reg = /^1(3|4|5|6|7|8|9)\d{9}$/
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入联系电话'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的联系电话'))
      } else {
        callback()
      }
    }
    return {
      loading: true,
      submitLoading: false,
      tabIndex: 1,
      formTitle: '',
      form: {
        id: undefined,
        categoryId: undefined,
        content: undefined,
        img: [],
        oriPrice: undefined,
        pic: undefined,
        prodName: undefined,
        prodType: 0,
        remark: undefined,
        oriPrice: 0,
        sort: 99,
        totalStocks: undefined,
        isSpec: 0,
        goldBeansPrice: 0,
        isRecommend: true,
        video: undefined,
        price: undefined,
        addParams: [
          {
            content: undefined,
            id: undefined,
            isServiceFee: undefined,
            maxPrice: undefined,
            pic: undefined,
            price: undefined,
            referencePrice: undefined,
            skuName: undefined,
            sort: undefined,
            status: undefined,
          },
        ],
      },
      isShowSpec: false,
      // 生成的skuList表格数据
      skuColumns: [
        { title: '规格组合', dataIndex: 'skuName', align: 'center' },
        { title: 'SKU名称', scopedSlots: { customRender: 'skuNameInput' }, align: 'center' },
        { title: '价格', scopedSlots: { customRender: 'price' }, align: 'center' },
        { title: '原价', scopedSlots: { customRender: 'oriPrice' }, align: 'center' },
        { title: '参考价', scopedSlots: { customRender: 'referencePrice' }, align: 'center' },
        { title: '最大限价', scopedSlots: { customRender: 'maxPrice' }, align: 'center' },
        { title: '库存', scopedSlots: { customRender: 'totalStocks' }, align: 'center' },
        { title: '图片', scopedSlots: { customRender: 'pic' }, align: 'center' },
        { title: '排序', scopedSlots: { customRender: 'sort' }, align: 'center' },
        { title: '状态', scopedSlots: { customRender: 'status' }, align: 'center' },
      ],
      curSpec: undefined,
      skuList: [],
      specs: [], // 当前选中的规格项
      replaceFields: {
        title: 'label',
        key: 'id',
        value: 'id',
        children: 'children',
      },
      statusOptions: [
        {
          label: '上架',
          value: 1,
        },
        {
          label: '下架',
          value: 0,
        },
      ],
      status: 1,
      // 上传图片
      open: false,
      previewVisible: false,
      showLoading: false,
      previewImage: '',
      fileList: [],
      rules: {
        goldBeansPrice: [{ required: true, message: '请输入商品金豆', trigger: 'blur' }],
        totalStocks: [{ required: true, message: '请输入总库存', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        prodName: [{ required: true, message: '请输入产品名称', trigger: 'blur' }],
        oriPrice: [{ required: true, message: '请输入维修基础原价', trigger: 'blur' }],
        img: [{ required: true, message: '请上传商品相册', trigger: 'blur' }],
        categoryId: [{ required: true, message: '请选择产品分类', trigger: 'blur' }],
        brief: [{ required: true, message: '请输入产品简介', trigger: 'blur' }],
        pic: [{ required: true, message: '请上传产品主图', trigger: 'blur' }],
        price: [{ required: true, message: '请输入维修基础现价', trigger: 'blur' }],
        content: [{ required: true, message: '请输入商品详情', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {},
  computed: {},
  watch: {},
  methods: {
    // 生成 SKU 列表
    generateSkuList() {
      const specs = this.specs.filter((s) => s.label && s.spec_value.length > 0)
      if (!specs.length) {
        this.$message.warning('请至少添加一个规格')
        return
      }

      const values = specs.map((s) => s.spec_value.map((v) => ({ key: s.label, value: v.label })))
      const combinations = this.cartesianProduct(values)

      this.addParams = combinations.map((combo, index) => {
        this.loading = false
        const skuName = combo.map((c) => c.value).join(' / ')
        const properties = combo.map((c) => `${c.key}:${c.value}`).join(';')
        return {
          content: '',
          id: null,
          isServiceFee: false,
          maxPrice: null,
          oriPrice: null,
          pic: '',
          price: null,
          properties,
          referencePrice: '',
          remark: '',
          skuName,
          sort: index,
          status: 1,
        }
      })

      this.skuList = this.addParams
    },

    // 笛卡尔积
    cartesianProduct(arr) {
      return arr.reduce((a, b) => a.flatMap((x) => b.map((y) => [...x, y])), [[]])
    },
    onClose() {
      const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          that.open = false
        },
        onCancel() {},
      })
    },
    /** 上传图片成功回调 */
    getImg(info, fieldName) {
      this.form[fieldName] = info
      this.$refs.form.clearValidate(fieldName)
    },
    changeSpec(e) {
      const value = e.target.value
      this.form.isSpec = value
    },
    changeTab(index, type) {
      if (type === 'next') {
        //  this.$refs.form.validate((valid, object) => {
        //   if (valid) {
        //     this.tabIndex = index + 1
        //   } else {
        //     return false
        //   }
        // })
        if (index == 1) {
          // this.$refs.form.validate(['categoryId', 'prodName'], (errors, values) => {
          //   if (!errors) {
          //     // 这些字段验证通过
          //     this.tabIndex = index + 1
          //   } else {
          //     // 这些字段验证失败，会自动变红
          //   }
          // })
          let validated = 0
          let allValid = true
          const fieldsToValidate = ['categoryId', 'prodName', 'brief', 'pic', 'img'] // 需要验证的字段名
          // 逐个验证字段
          fieldsToValidate.forEach((field) => {
            this.$refs.form.validateField(field, (error) => {
              validated++
              if (error) {
                allValid = false
              }
              // 当所有字段都验证完成后
              if (validated === fieldsToValidate.length) {
                if (allValid) {
                  this.tabIndex = index + 1
                  // 执行后续操作
                } else {
                }
              }
            })
          })
        } else if (index == 2) {
          let validatedCount = 0
          let allValid = true
          const fieldsToValidate2 = ['oriPrice', 'scorePrice', 'goldBeansPrice', 'totalStocks', 'sort'] // 需要验证的字段名
          // 逐个验证字段
          fieldsToValidate2.forEach((field) => {
            this.$refs.form.validateField(field, (error) => {
              validatedCount++
              if (error) {
                allValid = false
              }
              // 当所有字段都验证完成后
              if (validatedCount === fieldsToValidate2.length) {
                if (allValid) {
                  this.tabIndex = index + 1

                  // 执行后续操作
                } else {
                }
              }
            })
          })
        }
      } else if (type === 'back') {
        this.tabIndex = index - 1
      }
    },
    changeVideo(e) {
      const value = e.target.value
      this.isVideo = value
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick(function () {
        this.$refs.input.focus()
      })
    },
    showInputs() {
      this.inputVisibles = true
      this.$nextTick(function () {
        this.$refs.inputs.focus()
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 选择省
      onChangeProvince(e) {
      console.log(e, 'dddd点点滴')
      if (e.code) {
        this.form.province = e.value
      } else {
        this.form.province = ''
        this.form.city = ''
        this.form.area = ''
      }
    },
    /** 切换单规格还是多规格 **/
    handleChangeSpec(e) {
      this.curSpec = e
    },
    // 选择市
       onChangeCity(e) {
      if (e.code) {
        this.queryParam.city = e.value
      } else {
        this.queryParam.city = ''
        this.queryParam.area = ''
      }
    },
    // 选择区
      onChangeArea(e) {
      if (e.code) {
        this.queryParam.area = e.value
      } else {
        this.queryParam.area = ''
      }
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        categoryId: undefined,
        content: undefined,
        img: [],
        oriPrice: undefined,
        pic: undefined,
        prodName: undefined,
        prodType: 0,
        remark: undefined,
        scorePrice: 0,
        sort: 99,
        totalStocks: undefined,
        video: undefined,
        isSpec: 0,
        goldBeansPrice: 0,
        isRecommend: true,
        videoType: 1, // 1本地视频 2视频链接
      }
      this.tags = []
      this.tagslist = []
    },
    /** 新增按钮操作 */
    handleAdd(e) {
      this.tabIndex = 1
      this.reset()
      this.open = true
      if (e) {
        this.form.categoryId = e
      }
      this.formTitle = '添加商品'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.tabIndex = 1
      this.reset()
      const postId = row ? row.id : ids

      getObj(postId).then((response) => {
        response.data.isSpec = 0
        this.form = response.data
        this.open = true
        this.formTitle = '修改商品'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      if (this.form.goldBeansPrice == 0 && this.form.scorePrice == 0) {
        return this.$message.error('积分或金豆至少有一个不为0')
      }
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(1)
          })
          if (this.form.id !== undefined) {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          } else {
            addObj(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          }
        } else {
          const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
/deep/.ant-tabs-tab {
  border: none !important;
  padding-top: 0 !important;
}
.ant-tabs-bar {
  border: none !important;
  /* 取消元素的阴影效果 */
  box-shadow: none !important;
  height: 45px !important;
  padding-top: 5px !important;
}
</style>
